import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { firstValueFrom, take } from "rxjs";
import { UserService } from "./user.service";

export const canActivateRoute: CanActivateFn = async () => {
    const userService = inject(UserService);
    await firstValueFrom(userService.userStream.pipe(take(1)));
    return true;
};
